import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaSearch } from "react-icons/fa";
import serviceIcon from "../aseets/img/searchIcon.png";
import expertIcon from "../aseets/img/expertICon.png"
import personalizedIcon from '../aseets/img/serviceIcon.png'
import "../Css/WhyChuse.css";
import axios from "axios";


const WhyChusUS = () => {

  const [data, setdata] = useState([]);
  useEffect(() => {
    const fetchdata = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/auth/list/WhyUS-images`);
        
          setdata([response.data[0]]); 
        
      } catch (error) {
        console.error('Error fetching banner images:', error);
      }
    };

    fetchdata();

    
  }, []);
  return (
    <React.Fragment>
      <Container className="chusContainer">
        <Row className="serviceRow">
          <Col lg={6} md={6}>
            <div className="founderTitle">The Platinum Advantages</div>
            <div className="missonTite">Why Choose Us</div>
          </Col>
          {/* <Col className="contactUsCol" lg={6} md={6}>
            <Link className="contactUsLink" to="/contact-us">
              Contact Us
            </Link>
          </Col> */}
        </Row>
        <Row className="whyUsRow">
          <Col lg={6} md={6}>
            <img cla src={`${process.env.REACT_APP_API_URL}/${data[0]?.WhyUSImage}`} alt="img" />
          </Col>
          <Col lg={6} md={6}>
          {/* <div
        dangerouslySetInnerHTML={{ __html: data[0].Description }}
      /> */}
   <div   dangerouslySetInnerHTML={{ __html: data[0]?.Description }}
/>
          {/* <div className="serachMainDiv">
            <div className="searchDiv">
              <img className="searchIcon" src={serviceIcon} alt="icon" />
              <div className="searchTitle">Innovative Matchmaking</div>
            </div>
           
            <div className="aboutPera">
              Our unique approach combines traditional matchmaking expertise
              with cutting-edge technology. This ensures that every match is
              carefully selected based on compatibility, values, and lifestyle,
              offering a more meaningful connection.
            </div>
            </div>
            <div className="serachMainDiv">
            <div className="searchDiv">
              <img className="searchIcon" src={expertIcon} alt="icon" />
              <div className="searchTitle">Expert Guidance</div>
            </div>
            <div className="aboutPera">
              Our team of seasoned matchmakers provides personalized support at
              every stage of your journey. From your first consultation to
              relationship coaching, we ensure you’re fully prepared to find and
              nurture a lasting partnership.
            </div>
            </div>
            <div className="serachMainDiv">
            <div className="searchDiv">
              <img className="searchIcon" src={personalizedIcon} alt="icon" />
              <div className="searchTitle">Personalized Service</div>
            </div>
            <div className="aboutPera">
            We believe every individual is unique, and our service reflects that...
            </div>
            </div> */}
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default WhyChusUS;
